import { render, staticRenderFns } from "./LegacyLayout.vue?vue&type=template&id=3270f9e7&"
import script from "./LegacyLayout.vue?vue&type=script&lang=js&"
export * from "./LegacyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports